import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María González',
    city: 'Buenos Aires',
    avatar: 'https://i.pravatar.cc/100?img=1',
    text: 'Después de años intentando manifestar sin resultados, Realmanifestación me mostró que el problema estaba en mi identidad. En 3 semanas empecé a notar cambios reales. Mi relación con el dinero cambió completamente.'
  }, {
    name: 'Carlos Ramírez',
    city: 'Madrid',
    avatar: 'https://i.pravatar.cc/100?img=12',
    text: 'Llevaba meses estancado en mi negocio. Este método me ayudó a identificar los patrones que me saboteaban. En 2 meses dupliqué mis ingresos y mejoré todas mis relaciones.'
  }, {
    name: 'Ana Martínez',
    city: 'CDMX',
    avatar: 'https://i.pravatar.cc/100?img=5',
    text: 'Nunca había encontrado algo tan completo. No es solo teoría, son herramientas prácticas. Mi claridad mental aumentó y finalmente entendí por qué mi realidad no cambiaba. Vale cada peso.'
  }, {
    name: 'Diego Torres',
    city: 'Bogotá',
    avatar: 'https://i.pravatar.cc/100?img=15',
    text: 'Estaba escéptico, pero decidí probar. Los primeros días sentí un cambio en mi energía. Los ejercicios de reprogramación son potentes y los resultados son medibles. Totalmente recomendado.'
  }, {
    name: 'Laura Sánchez',
    city: 'Santiago',
    avatar: 'https://i.pravatar.cc/100?img=9',
    text: 'He leído muchos libros de manifestación pero ninguno me dio resultados hasta este. La diferencia está en el enfoque: trabaja desde la raíz. Mi autoestima y mis relaciones mejoraron muchísimo.'
  }, {
    name: 'Roberto Fernández',
    city: 'Lima',
    avatar: 'https://i.pravatar.cc/100?img=13',
    text: 'Lo mejor que he invertido en mi desarrollo personal. Cada protocolo tiene un propósito claro. Pasé de sentirme perdido a tener total claridad sobre mi propósito y mis metas.'
  }, {
    name: 'Valentina Ruiz',
    city: 'Montevideo',
    avatar: 'https://i.pravatar.cc/100?img=10',
    text: 'No es un libro más, es un sistema completo de transformación. Los bonos son increíbles y el contenido principal es oro puro. En 1 mes ya veo cambios en mi economía y mi paz mental.'
  }, {
    name: 'Javier López',
    city: 'Guadalajara',
    avatar: 'https://i.pravatar.cc/100?img=14',
    text: 'Después de probar todo sin éxito, esto me dio las respuestas. El enfoque en la identidad es lo que marca la diferencia. En 6 semanas logré más que en 2 años intentando otras cosas.'
  }, {
    name: 'Sofía Morales',
    city: 'Rosario',
    avatar: 'https://i.pravatar.cc/100?img=16',
    text: 'Este método cambió mi vida. Tenía bloqueos económicos y emocionales que no podía superar. Los protocolos me ayudaron a eliminarlos. Ahora tengo más confianza y abundancia.'
  }, {
    name: 'Miguel Herrera',
    city: 'Quito',
    avatar: 'https://i.pravatar.cc/100?img=11',
    text: 'Diferente a todo lo que había probado. No te vende humo, te da herramientas reales. Los ejercicios son profundos y los resultados son permanentes. Si dudas, no lo hagas. Cómpralo ya.'
  }];
  return <section className="px-4 py-7 sm:py-9 border-t border-brand-gold/10" data-id="element-159">
      <div className="max-w-6xl mx-auto" data-id="element-160">
        <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-5 sm:mb-6" data-id="element-161">
          Miles ya comenzaron su{' '}
          <span className="text-brand-gold" data-id="element-162">transformación</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4" data-id="element-163">
          {testimonials.map((testimonial, i) => <div key={i} className="bg-dark-card border border-brand-gold/20 rounded-lg p-4" data-id="element-164">
              <div className="flex items-start gap-3 mb-2" data-id="element-165">
                <img src={testimonial.avatar} alt={testimonial.name} className="w-10 h-10 rounded-full" data-id="element-166" />
                <div className="flex-1 min-w-0" data-id="element-167">
                  <h4 className="font-semibold text-sm" data-id="element-168">{testimonial.name}</h4>
                  <p className="text-xs text-brand-gray" data-id="element-169">{testimonial.city}</p>
                  <div className="flex items-center gap-0.5 mt-0.5" data-id="element-170">
                    {[...Array(5)].map((_, i) => <span key={i} className="text-brand-gold text-xs" data-id="element-171">
                        ★
                      </span>)}
                  </div>
                </div>
                <span className="text-[10px] bg-brand-gold/20 text-brand-gold px-2 py-0.5 rounded whitespace-nowrap" data-id="element-172">
                  Verificada
                </span>
              </div>
              <p className="text-xs sm:text-sm text-brand-gray leading-relaxed" data-id="element-173">
                {testimonial.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}